import { idsFacilities, idFacility } from '@fr/vue/pages/serp/components/filters/facilitiesFilter/common';

export default function (idsTypes: number[], idsAttributes: number[]): idsFacilities[] {
    // Каждый Set строится один раз, дальше — O(1) проверки вместо ~20 линейных _.contains.
    const typeIds = new Set(idsTypes);
    const attributeIds = new Set(idsAttributes);
    const result: idsFacilities[] = [];

    if (!attributeIds.has(250)) result.push(idFacility.lonelyMan);
    if (attributeIds.has(264)) result.push(idFacility.bayLocated);
    if (attributeIds.has(217)) result.push(idFacility.adultsOnly);
    if (isHotelHasAirConditioner(attributeIds)) result.push(idFacility.airConditioner);
    if (isHotelHasWifi(attributeIds)) result.push(idFacility.wifi);
    if (attributeIds.has(166)) result.push(idFacility.withAnimals);
    if (attributeIds.has(147)) result.push(idFacility.spaAndHealth);
    if (attributeIds.has(185) || attributeIds.has(64)) result.push(idFacility.jacuzzi);
    if (attributeIds.has(69) || attributeIds.has(263)) result.push(idFacility.parking);
    if (attributeIds.has(148) || attributeIds.has(149)) result.push(idFacility.saunaBathHammam);
    if (isHotelHasForCouples(typeIds, attributeIds)) result.push(idFacility.forCouples);
    if (isHotelHasWithKids(typeIds, attributeIds)) result.push(idFacility.withKids);
    return result;
}

function isHotelHasAirConditioner(attributeIds: Set<number>): boolean {
    return attributeIds.has(83)
        || attributeIds.has(212)
        || attributeIds.has(233);
}

function isHotelHasWifi(attributeIds: Set<number>): boolean {
    return attributeIds.has(74)
        || attributeIds.has(88)
        || attributeIds.has(226)
        || attributeIds.has(227)
        || attributeIds.has(234)
        || attributeIds.has(237);
}

function isHotelHasForCouples(typeIds: Set<number>, attributeIds: Set<number>): boolean {
    return typeIds.has(8)
        || attributeIds.has(169)
        || attributeIds.has(220)
        || attributeIds.has(217);
}

function isHotelHasWithKids(typeIds: Set<number>, attributeIds: Set<number>): boolean {
    return typeIds.has(5)
        || attributeIds.has(109)
        || attributeIds.has(229)
        || attributeIds.has(112);
}
